import React, { useRef, useState } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import AppContainer from "../../../../container";
import Button from "../../../button";
import { IUserService, UserService } from "../../../../services/user.service";
import ProfileProgramForm from "../forms/profile-program-form";
import UserDialogTitle from "../user-dialog-title";
import { UserDialogTabProps } from "../";
import LoyaltyProgramModel from "../../../../models/loyalty-program.model";
import useModal from "../../../../hooks/use-modal.hook";
import useSnackbar from "../../../../hooks/use-snackbar.hook";

interface Props extends UserDialogTabProps {
  program?: LoyaltyProgramModel;
}

export default function ProfileProgramTab(props: Props) {
  const { program, onSave, onViewChange, user } = props;
  const userService: IUserService = AppContainer.get(UserService);
  const { openModal } = useModal();
  const { setSnackbar } = useSnackbar();
  const isNew = !Boolean(program);

  const [formValid, setFormValid] = useState<boolean>(false);
  const [readOnly, setReadOnly] = useState<boolean>(true);

  const formRef = useRef();

  let titleText = "Edit";

  if (isNew) {
    titleText = "Add";
  } else if (readOnly) {
    titleText = "View";
  }

  const titleElement = <div>{titleText} Program</div>;

  const handleDelete = () => {
    if (!program) {
      return;
    }

    openModal("confirm", {
      dialogTitle: `Delete Progam`,
      dialogBody: `Are you sure you want to delete this program? This cannot be undone.`,
      onConfirm: async () => {
        const userPrograms = { ...user.loyaltyPrograms };
        userPrograms[program.company] = new LoyaltyProgramModel();

        const updatedUser = await userService.update(
          user.id,
          {
            loyaltyPrograms: userPrograms
          },
          true
        );

        if (updatedUser) {
          onSave && onSave(updatedUser);
          onViewChange("profile-view");
          setSnackbar({
            message: `Program deleted!`,
            variant: "success"
          });
        }
      }
    });
  };

  return (
    <React.Fragment>
      <UserDialogTitle
        {...props}
        deleteTooltip="Delete Program"
        hideClose={true}
        onDelete={isNew ? undefined : handleDelete} // hide delete if creating new program
        title={titleElement}
      />
      <DialogContent
        classes={{ root: "dialog-content" }}
        className="not-draggable"
      >
        <div className="user-dialog__content">
          <div>
            {
              <ProfileProgramForm
                {...props}
                onSave={onSave}
                onReadOnly={() => setReadOnly(false)}
                onValidate={setFormValid}
                readOnly={!isNew ? readOnly : false}
                ref={formRef}
              />
            }
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="gray"
          isTransparent={true}
          label={readOnly ? "Back" : "Cancel"}
          onClick={() => onViewChange("profile-view")}
          size="medium"
        />

        {(!readOnly || isNew) && (
          <Button
            color="product-blue"
            isDisabled={!formValid}
            label="Save Program"
            onClick={() => {
              formRef.current && (formRef.current as any).save();
            }}
            size="medium"
          />
        )}
      </DialogActions>
    </React.Fragment>
  );
}
